import { render, staticRenderFns } from "./HasBeenDownloadedColumn.vue?vue&type=template&id=4a873299"
import script from "./HasBeenDownloadedColumn.ts?vue&type=script&lang=ts&external"
export * from "./HasBeenDownloadedColumn.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a873299')) {
      api.createRecord('4a873299', component.options)
    } else {
      api.reload('4a873299', component.options)
    }
    module.hot.accept("./HasBeenDownloadedColumn.vue?vue&type=template&id=4a873299", function () {
      api.rerender('4a873299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Bills/components/list/columns/HasBeenDownloadedColumn/HasBeenDownloadedColumn.vue"
export default component.exports